module.exports = __webpack_public_path__ + "img/company_2.92aa0ed2.png";